import theme from '../../../lib/theme';

const {
  scale,
  layouts,
  colors,
  media
} = theme;

export default () => ({
  container: {
    ...layouts.column,

    borderBottom: `1px solid ${colors.grey}`,
    color: colors.black,
    alignItems: 'center',
    padding: `0 ${scale.xs} ${scale.s}`,

    [media.s.up]: {
      padding: `0 ${scale.s} ${scale.m}`,
    },
  },
});
